var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 264.018 264.018",
    style: {
      enableBackground: "new 0 0 264.018 264.018"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M132.009 0c-42.66 0-77.366 34.706-77.366 77.366 0 11.634 2.52 22.815 7.488 33.24.1.223.205.442.317.661l58.454 113.179a12.502 12.502 0 0 0 22.212 0l58.438-113.148c.101-.195.195-.392.285-.591 5.001-10.455 7.536-21.67 7.536-33.341C209.375 34.706 174.669 0 132.009 0zm0 117.861c-22.329 0-40.495-18.166-40.495-40.495 0-22.328 18.166-40.494 40.495-40.494s40.495 18.166 40.495 40.494c0 22.329-18.166 40.495-40.495 40.495zM161.81 249.018h-59.602a7.499 7.499 0 0 0-7.5 7.5c0 4.143 3.357 7.5 7.5 7.5h59.602c4.143 0 7.5-3.357 7.5-7.5a7.5 7.5 0 0 0-7.5-7.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.6ad7e38a297edc104320ff864125c490.svg";
export { ForwardRef as ReactComponent };